import {
  UserOutline,
  StarOutline,
  MoneyOutline,
  GiftOutline,
  HelmetOutline,
  FileAltOutline
} from '@backyard-ui/icons'

export const CATEGORY_ICONS = {
  cadastro: UserOutline,
  pontos: StarOutline,
  cashback: MoneyOutline,
  beneficios: GiftOutline,
  'categorias-especiais': HelmetOutline,
  'regras-gerais': FileAltOutline
}
